import { render } from "./GeneralSalary.vue?vue&type=template&id=aa37354a"
import script from "./GeneralSalary.vue?vue&type=script&lang=js"
export * from "./GeneralSalary.vue?vue&type=script&lang=js"

import "./GeneralSalary.vue?vue&type=style&index=0&id=aa37354a&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__